module.exports = __webpack_public_path__ + "img/img_list_11@2x.c0461e23.png";